export default {
  white: '#FFFFFF',
  black: '#000000',
  lightGrey: '#F5F5F5',
  acidGreen: '#DCFF58',
  warmGrey: '#D6CFC1'
};
